// Funciones de detección de dispositivos para optimización de rendimiento

/**
 * Detecta si es un dispositivo Android (cualquier navegador)
 */
export const isAndroidDevice = () => {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
};

/**
 * Detecta si es un dispositivo iOS
 */
export const isIOSDevice = () => {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

/**
 * Detecta si es un dispositivo móvil (Android, iOS u otros)
 */
export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * Detecta si es una pantalla pequeña (< 768px)
 */
export const isSmallScreen = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768;
};

/**
 * Detecta si debe usar modo de bajo rendimiento
 * (móvil O pantalla pequeña)
 */
export const isLowPerformanceMode = () => {
  return isMobileDevice() || isSmallScreen();
};

/**
 * Detecta si es Android WebView específicamente
 * (mantener por compatibilidad)
 */
export const isAndroidWebView = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /Android/.test(ua) && (/wv/.test(ua) || /Version\/[\d.]+.*Chrome/.test(ua));
};

/**
 * Detecta si debe forzar vista de día en móvil
 */
export const shouldForceDayView = () => {
  return isMobileDevice() || isSmallScreen();
};
